import { Component, Input, OnInit } from "@angular/core";
import { CoreUiExtensionsStateService } from "@modules/core-ui-extensions/services";
import { ClaimDetailsStateService } from "@modules/core/state";
import { Observable } from "rxjs";

@Component({
  selector: "cla-tree-party-contact-card",
  templateUrl: "./tree-party-contact-card.component.html",
  standalone: false,
})
export class TreePartyContactCardComponent implements OnInit {
  constructor(
    public coreUiExtensionsStateService: CoreUiExtensionsStateService,
    public claimDetailsStateService: ClaimDetailsStateService
  ) {}

  @Input() partyId: string;
  @Input() partyName: string;
  @Input() hasAttorney: boolean;
  @Input() propertyId: string;

  seatbeltIndicator$!: Observable<string | null>;

  get buttonAriaText(): string {
    return "Open party contact card for " + this.partyName;
  }

  onPopoverOpen(): void {
    this.coreUiExtensionsStateService.getPartySummaries(this.partyId);
  }

  ngOnInit(): void {
    this.seatbeltIndicator$ =
      this.claimDetailsStateService.selectSeatbeltIndicatorByPartyAndPropertyId(
        {
          propertyId: parseInt(this.propertyId),
          partyId: parseInt(this.partyId),
        }
      );
  }
}
